import React from 'react';
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';

const tooltipStyle = {
  backgroundColor: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '8px',
  fontSize: '12px',
  color: '#1e293b'
};

const ChatChart = ({ chart }) => {
  if (!chart?.data?.length) return null;

  const { type = 'line', title, xKey = 'time', yKey = 'value', yLabel, data } = chart;

  const commonProps = {
    data,
    margin: { top: 8, right: 12, left: 0, bottom: 0 }
  };

  const renderSeries = () => {
    if (type === 'bar') {
      return <Bar type="monotone" dataKey={yKey} fill="#0ea5e9" radius={[4, 4, 0, 0]} />;
    }
    if (type === 'area') {
      return (
        <>
          <defs>
            <linearGradient id="chatChartFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#0ea5e9" stopOpacity={0.35} />
              <stop offset="95%" stopColor="#0ea5e9" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <Area type="monotone" dataKey={yKey} stroke="#0284c7" strokeWidth={2} fill="url(#chatChartFill)" dot={false} />
        </>
      );
    }
    return <Line type="monotone" dataKey={yKey} stroke="#0284c7" strokeWidth={2} dot={false} activeDot={{ r: 4 }} />;
  };

  const ChartComponent = type === 'bar' ? BarChart : type === 'area' ? AreaChart : LineChart;

  return (
    <div className="mt-3 overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
      {title && (
        <div className="border-b border-slate-200 px-3 py-2 text-xs font-medium text-slate-600">
          {title}
        </div>
      )}
      <div className="p-2">
        <ResponsiveContainer width="100%" height={220}>
          <ChartComponent {...commonProps}>
            <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
            <XAxis
              dataKey={xKey}
              tick={{ fontSize: 10, fill: '#64748b' }}
              interval="preserveStartEnd"
              minTickGap={24}
            />
            <YAxis
              tick={{ fontSize: 10, fill: '#64748b' }}
              width={42}
              tickFormatter={(value) => Number(value).toFixed(1)}
            />
            <Tooltip
              contentStyle={tooltipStyle}
              formatter={(value) => [Number(value).toFixed(2), yLabel || 'Value']}
              labelFormatter={(label) => `Time: ${label}`}
            />
            {renderSeries()}
          </ChartComponent>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ChatChart;
